<div class="input-container">
  <div class="input-cell">
    <span class="input-flex flex-right">
      <p-autoComplete
        [disabled]="disabled"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="promo"
        [suggestions]="filteredPromos"
        placeholder="Type to search a Promo"
        field="name"
        (completeMethod)="filter($event)"
        (onSelect)="addPromo.emit($event); promo = ''"
        styleClass="autocomplete-tile complete-input"
        inputStyleClass="complete-input"
      >
        <ng-template let-item pTemplate="item">
          <ad-tile [data]="item" hoverActive="1"></ad-tile>
        </ng-template>
      </p-autoComplete>
    </span>
  </div>
</div>
